import React from "react";


export default function HorizontalMiniCards({items}) {
    // items = List of objects
    return (
        <div
            className="elementor-element elementor-element-8c0b439 e-flex e-con-boxed e-con e-parent"
            data-id="8c0b439"
            data-element_type="container"
        >
            <div className="e-con-inner flex flex-wrap md:flex-nowrap gap-6 md:gap-0 justify-between">
                {items.map((item, index) => (
                    <div
                        key={index}
                        className="elementor-element elementor-element-363e4a7 im-bx-r elementor-widget__width-initial elementor-position-top elementor-widget elementor-widget-image-box w-full md:w-auto"
                        data-id="363e4a7"
                        data-element_type="widget"
                        data-widget_type="image-box.default"
                    >
                        <div className="elementor-widget-container text-center md:text-left px-4 md:px-0">
                            <div className="elementor-image-box-wrapper flex flex-col items-center md:items-start">
                                <figure className="elementor-image-box-img mb-2">
                                    <img
                                        decoding="async"
                                        width={87}
                                        height={87}
                                        src={item.image}
                                        className="attachment-full size-full wp-image-1734"
                                        alt={`${item.text} icon`}
                                    />
                                </figure>
                                <div className="elementor-image-box-content">
                                    <h3 className="elementor-image-box-title ">
                                        {item.text}
                                    </h3>
                                    <p className="elementor-image-box-description ">
                                        {item.subtext}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Mobile-specific styles */}
            <style>
                {`
                @media (max-width: 767px) {
                    .elementor-element-363e4a7 {
                        margin-bottom: 1.5rem;
                    }

                    .elementor-image-box-img img {
                        width: 80px !important;
                        height: 80px !important;
                    }

                    .elementor-image-box-title {
                        font-size: 1.5rem !important;
                        line-height: 1.5 !important;
                    }

                    .elementor-image-box-description {
                        font-size: 1rem !important;
                        line-height: 1.4 !important;
                    }
                    
                    .elementor-image-box-content {
                       text-align: center !important;
                    }
                }
            `}
            </style>
        </div>
    );
}
